/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.EventSchedule {
    angular.module("meevo.plugins.eventSchedule", []);
}